var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { HookerActiveTree } from './modules/HookerActiveTree';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { HookerTraitActive } from './modules/HookerTraitActive';
export class Hooker {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get app() {
        return this.parent.app;
    }
    get hookDirectorActiveTree() {
        return new HookerActiveTree(this);
    }
    get hookDirectorTraitActive() {
        return new HookerTraitActive(this);
    }
    enableAllHooks() {
        this.hookDirectorActiveTree.enableHook();
        this.hookDirectorTraitActive.enableHook();
        const activateEvents = this.parent.eventor;
    }
}
__decorate([
    memoize
], Hooker.prototype, "hookDirectorActiveTree", null);
__decorate([
    memoize
], Hooker.prototype, "hookDirectorTraitActive", null);
__decorate([
    action.bound
], Hooker.prototype, "enableAllHooks", null);
